export default class wdkDialogConfirm extends HTMLElement {
	async connectedCallback() {
		await new Promise(requestAnimationFrame);
		this.#appendMarkup();

		this.querySelector('.js-closeConfirm')?.addEventListener('click', (event) => {
			event.preventDefault();
			this.closeConfirm();
		});

		this.closest('wdk-dialog')
			.querySelector('wdk-dialog-confirm .js-forceCloseDialog')
			?.addEventListener('click', () => {
				this.closest('wdk-dialog').closeModal(true);
			});
	}

	#appendMarkup() {
		const confirmElement = document.createElement('template');
		confirmElement.innerHTML = `
			<style>
				:host(:not([open])) {
					display: none;
				}
				
				:host {
					--inline-padding: 12px;
				}

				@media only screen and (min-width: 601px) {
					:host {
						--inline-padding: 24px;
					}
				}
				
				:host([open]) {
					display: flex;
					justify-content: center;
					align-items: center;
					position: absolute;
					top: 0;
					left: 0;
					background-color: var(--COLOR_support_black_alpha_15);
					width: 100%;
					height: 100%;
					border-radius: var(--RADIUS_M);
				}
				
				.dialogContent {
					height: fit-content;
					width: 100%;
					margin: 0 16px;
					background-color: var(--COLOR_support_white_default);
					border-radius: var(--RADIUS_M);
					box-shadow: var(--SHADOW_M);
				}
				
				@media only screen and (min-width: 601px) {
					.dialogContent {
						width: 70%;
						margin: 0;
					}
				}
				
				.dialogContent > header h2 {
					display: flex;
					align-items: center;
					min-height: 60px;
					margin: 0;
					padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
					font: var(--FONT_default_200);
					color: var(--COLOR_defaultText);
				}
				
				.dialogContent > article {
					display: flex;
					flex-direction: column;
					padding: 0 var(--inline-padding);
				}
				
				.dialogContent > footer {
					padding: 24px var(--inline-padding);
				}
				
				.dialogContent > footer ul {
					width: 100%;
					display: flex;
					flex-flow: wrap;
					gap: 20px;
					justify-content: space-between;
					margin: 0;
					padding: 0;
				}
				
				.dialogContent > footer ul li {
					flex-basis: calc(40% - 20px);
					flex-grow: 1;
					list-style: none;
					text-align: center;
					vertical-align: top;
					margin: 0;
					padding: 0;
				}
				
				/* Full width for Buttons if shown in 2 lines */
				.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
					width: 100%;
				}
			</style>
			<div class="dialogContent">
				<header><h2><slot name="headline"></slot></h2></header>
				<article><slot></slot></article>
				<footer>
					<ul>
						<li><slot name="button_1"></slot></li>
						<li><slot name="button_2"></slot></li>
					</ul>
				</footer>
			</div>
		`;

		const clone = document.importNode(confirmElement.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}

	openConfirm() {
		this.setAttribute('open', '');
	}

	closeConfirm() {
		this.removeAttribute('open');
	}
}
